module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-It.06248f33.otf";